import { isLanguage, Language } from '../../../../../../../types/language'

const CONTACTS_IMPORT_FAQ_LINKS: Partial<Record<Language, string>> = {
  en: 'https://help.shine.co/en/articles/661602-import-my-clients',
  da: 'https://help.shine.co/da/articles/661602-importer-mine-kunder',
  de: 'https://help.shine.co/de/articles/661602-meine-kund-innen-importieren',
  fr: 'https://help.shine.fr/shine-facture/fr/articles/14134276-importer-mes-client-es',
  nl: 'https://help.shine.co/nl/articles/661602-mijn-klanten-importeren',
}

export const getFaqLink = (localeCode: string | undefined) => {
  const language: Language = isLanguage(localeCode) ? localeCode : 'en'
  return CONTACTS_IMPORT_FAQ_LINKS[language] ?? CONTACTS_IMPORT_FAQ_LINKS.en
}
